import { recordEventCustomOnly } from 'utilities/uTagging';

export const doTagShowReidentificationModal = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'modal',
        component: 'modal/reidentify',
        element: 'full',
        eventCategory: '/onboarding/step6/identityselfie',
        eventAction: 'reidentify',
        eventLabel: 'open',
    });
};

export const doTagReidentificationModalCancel = () => {
    recordEventCustomOnly({
        action: 'close',
        format: 'cross',
        component: 'modal/reidentify',
        element: 'close',
        eventCategory: '/onboarding/step6/identityselfie',
        eventAction: 'reidentify',
        eventLabel: 'close',
    });
};

export const doTagReidentificationModalContinue = () => {
    recordEventCustomOnly({
        action: 'continue',
        format: 'button',
        component: 'modal/reidentify',
        element: 'continue',
        eventCategory: '/onboarding/step6/identityselfie',
        eventAction: 'reidentify',
        eventLabel: 'continue',
    });
};
